export default function range(n) {
    return Array(n)
        .fill('_')
        .map((_, i) => i);
}
